import { useApiClient } from "@albertine/api-client";
import type {
    ListAllPaymentsData,
    ListAllPaymentsItem,
} from "@albertine/types/openapi";
import PaginatedList from "../Common/list/PaginatedList";
import { PaymentRow } from "./PaymentRow";
import { type PaymentsListFilter, queryListAllPaymentsApi } from "./paymentsList.util";

const PAGE_SIZE = 50;

export type PaymentsPaginatedResultsProps = {
    filter: PaymentsListFilter;
    onPageLoaded: (data: ListAllPaymentsData) => void;
};

export function PaymentsPaginatedResults({
    filter,
    onPageLoaded,
}: PaymentsPaginatedResultsProps) {
    const { apiClient } = useApiClient();

    const queryForItems = async ({ size, page }: { size: number; page: number }) => {
        const result = await queryListAllPaymentsApi(apiClient, filter, page, size);
        onPageLoaded(result);
        return {
            data: result.payments,
            total: result.total,
        };
    };

    return (
        <PaginatedList<number, ListAllPaymentsItem>
            className="w-full animate-fade-in"
            pageLength={PAGE_SIZE}
            queryKey={["list-payments", filter]}
            queryForItems={queryForItems}
            renderItem={(row) => <PaymentRow key={row.id} row={row} />}
            renderError={() => (
                <div className="p-5 text-center text-(--a-ds-font-color-secondary)">
                    Something went wrong loading payments.
                </div>
            )}
        />
    );
}
